<template>
  <div style="width: 100%" @click="click">
    <font-awesome-icon icon="arrow-left" size="lg" />
    Get back
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { ElMessage } from 'element-plus'
import appEnv from '@/support/env'

export default defineComponent({
  name: 'GetBackButton',
  setup() {
    const userStore = useUserStore()
    const click = async () => {
      try {
        await userStore.GetBack()
        window.location.href = `${appEnv.MAIN_APP_ADMIN}/adm/users`
      } catch {
        ElMessage.warning({
          message: 'Cant perform this action',
          type: 'warning',
          showClose: true,
          duration: 5000
        })
      }
    }
    return { click }
  }
})
</script>
